<template>
  <div class="feedback-wrapper">
    <span>{{ data.age }} år, {{ data.gender }}:</span>
    <div class="feedback">{{ data.message }}</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: {},
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.feedback-wrapper {
  margin: 20px 0;
  max-width: $content-max-width;
}

.feedback {
  background-color: $green;
  border-radius: 20px;
  color: $white;
  margin-top: 10px;
  padding: 20px;
}
</style>
